import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-data-access-agreement-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    FormsModule,
    MatIconModule,
  ],
  template: `<h2 mat-dialog-title class="title">
      Data Access Licence Agreement
    </h2>
    <mat-dialog-content>
      <p class="warning">
        WARNING: PERMISSION TO USE THE LICENSED MATERIAL THAT ACCOMPANIES THIS
        AGREEMENT IS CONDITIONAL UPON YOU, THE CUSTOMER (LICENSEE) ACCEPTING THE
        TERMS SET OUT BELOW.
      </p>

      <h3>You are free:</h3>
      <ul>
        <li>to copy, distribute, display and perform the work;</li>
        <li>to make derivative works;</li>
        <li>to make commercial use of the work;</li>
      </ul>

      <h3>
        Under the following conditions: Attribution - You must give the original
        author credit.
      </h3>
      <h3>With the understanding that:</h3>
      <ul>
        <li>
          Waiver - Any of the above conditions can be waived if you get
          permission from the copyright holder.
        </li>
        <li>
          Public Domain - Where the work or any of its elements is in the public
          domain under applicable law, that status is in no way affected by the
          licence
        </li>
        <li>
          Other Rights - In no way are any of the following rights affected by
          the licence
          <ul>
            <li>
              Your fair dealing or fair use rights, or other applicable
              copyright exceptions and limitations;
            </li>
            <li>The author's moral rights;</li>
            <li>
              Rights other persons may have either in the work itself or in how
              the work is used, such as publicity or privacy rights
            </li>
          </ul>
        </li>
      </ul>

      <div class="notice">
        <mat-icon class="notice-icon">notifications_none</mat-icon>
        <p>
          Notice - for any reuse or distribution, you must make clear to others
          the licence terms of this work.
        </p>
      </div>

      <div class="creative-commons-link">
        <p>
          This is a human-readable summary of the Legal Code which may be
          accessed from
        </p>
        <a
          href="https://www.creativecommons.org/licenses/by/3.0/legalcode"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.creativecommons.org/licenses/by/3.0/legalcode
        </a>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="start" class="dialog-actions">
      <button mat-flat-button (click)="onAccept()">Accept</button>
      <button mat-button (click)="onReject()">Reject</button>
    </mat-dialog-actions>`,
  styles: `
    @use 'breakpoints' as *;
    .title {
      font-weight: bold;
    }
    .warning {
      font-weight: bold;
    }

    .notice {
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: #e3f2fd;
      padding: 10px;
      margin: 10px 0;

      .notice-icon {
        flex-shrink: 0;
        margin-right: 16px;
        width: 24px;
        height: 24px;
      }

      p {
        flex: 1;
      }

      @include web {
        .notice-icon {
          width: 32px;
          height: 32px;
          margin-right: 0;
        }
      }
    }

    .creative-commons-link {
      word-break: break-word;
      p {
        margin: 0;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataAccessAgreementDialogComponent {
  dialogRef = inject(MatDialogRef<DataAccessAgreementDialogComponent>);

  onAccept(): void {
    this.dialogRef.close(true);
  }

  onReject(): void {
    this.dialogRef.close(false);
  }
}
